import React, { useEffect, useState } from "react";
import { Box, Typography, Link, Stack, Container } from "@mui/material";
import { BASE_URL } from "../config/network/ApiUrl";

const Footer = () => {
  const [images, setImages] = useState([]);

  // Fetch images using async/await with GET method
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/dyk-images`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Image data", data)

        if (data?.images) {
          setImages(data.images);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  console.log("images", images)
  return (
    <>
     <br></br>
      {/* Section Above Footer */}
      {images?.length === 1 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 4,
            backgroundColor: "#f1f1f1",
          }}
        >
          {images.map((img) => (
            <Box key={img.id} sx={{ maxWidth: "100%", }}>
              {img.link ?
                <a
                  href={img.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  
                >
                  <Box
                    component="img"
                    src={img.url}
                    alt={`Banner ${img.id}`}
                    sx={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                  />
                </a>
                : <Box
                  component="img"
                  src={img.url}
                  alt={`Banner ${img.id}`}
                  sx={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />

              }

            </Box>
          ))}
        </Box>
      )}

      {images?.length === 2 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap:0,
            py: 4,
            backgroundColor: "#f1f1f1",
          }}
        >
          {images.map((img) => (
            <Box key={img.id} sx={{ maxWidth: "100%" }}>
              {img.link ?
                <a
                  href={img.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box
                    component="img"
                    src={img.url}
                    alt={`Banner ${img.id}`}
                    sx={{
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </a>
                : <Box
                  component="img"
                  src={img.url}
                  alt={`Banner ${img.id}`}
                  sx={{
                    width: "100%",
                    height: "auto",
                  }}
                />

              }

            </Box>
          ))}
        </Box>
      )}
     <br></br>
      {/* Footer Section */}
      <Box
        sx={{
          backgroundColor: "#333333",
          color: "#ffffff",
          py: 3,
          px: { xs: 1, sm: 1, md: 8 },
          mt: 0,

        }}
      >
        <Container>
          <Typography variant="body2" sx={{
            mb: { xs: 1, md: 4 },
            fontFamily: "OpenSans-Regular",
            fontSize: "15px",
            color: "#ffffff",
            lineHeight: "18px",
            marginLeft: "-1%"
          }}>
            To share your stories, connect with us at{" "}
            <Link
              href="mailto:group.communication@mahindramail.com"
              sx={{
                fontWeight: 600, color: "#ffffff", textDecoration: "none", "&:hover": {
                  color: "#e31837",
                },
              }}
            >
              group.communication@mahindramail.com
            </Link>
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            flexWrap="wrap"
            alignItems="center"
            sx={{ marginLeft: "-1%" }}

          >
            <Typography sx={{
              fontFamily: "'OpenSans-Regular'",
              fontSize: "15px",
              color: "#989797",
              lineHeight: "18px",
              display: { md: "block", xs: "none" }
            }}>
              Copyright © 2025 Mahindra & Mahindra Ltd. All rights reserved.
            </Typography>
            {/* LINKS WITH SEPARATORS */}
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Link
                href="https://www.mahindra.com/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontFamily: "'OpenSans-Regular'",
                  fontSize: "15px",
                  color: "#ffffff",
                  lineHeight: "18px",
                  textDecoration: "none", "&:hover": {
                    color: "#e31837",
                  }
                }}

              >
                Terms of Use
              </Link>

              <Typography
                sx={{
                  fontSize: "15px",
                  color: "#ffffff",
                  fontFamily: "'OpenSans-Regular'",
                  fontWeight: 100,
                  opacity: .8,

                }}
              >
                |
              </Typography>

              <Link
                href="https://www.mahindra.com/disclaimer"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontFamily: "'OpenSans-Regular'",
                  fontSize: "15px",
                  color: "#ffffff",
                  lineHeight: "18px",
                  textDecoration: "none", "&:hover": {
                    color: "#e31837",
                  }
                }}
              >
                Disclaimer
              </Link>
              <Typography
                sx={{
                  fontSize: "15px",
                  color: "#ffffff",
                  fontFamily: "'OpenSans-Regular'",
                  fontWeight: 200,
                  opacity: .8,
                }}
              >
                |
              </Typography>
              <Link
                href="https://www.mahindra.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontFamily: "'OpenSans-Regular'",
                  fontSize: "15px",
                  color: "#ffffff",
                  lineHeight: "18px",
                  textDecoration: "none", "&:hover": {
                    color: "#e31837",
                  }
                }}
              >
                Privacy Policy
              </Link>
            </Stack>
            <Typography sx={{
              fontFamily: "'OpenSans-Regular'",
              fontSize: "15px",
              color: "#989797",
              lineHeight: "18px",
              display: { md: "none", xs: "block" },
            }}>
              Copyright © 2025 Mahindra & Mahindra Ltd. All rights reserved.
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Footer;